import type { PayloadAction } from '@reduxjs/toolkit';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import history from '../history';
import { mergeCasesActions, navigationIntentActions } from '@codametrix/ui-common';

const { navigationIntent } = navigationIntentActions;
const { launchInAmplify } = mergeCasesActions;

const NAVIGATION_ROUTES: Record<string, string> = {
  NOT_AUTHORIZED: '/not-authorized/',
  CASE_NOT_FOUND: '/case-not-found/',
  CASE_CHOOSER: '/case-chooser/',
  EULA: '/eula/',
  SESSION_OPENED: '/session-opened/',
  CONTEXT_UNAVAILABLE: '/context-unavailable/',
  TIMED_OUT: '/timed-out/',
};

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof navigationIntent> =>
    action.type === navigationIntent.type,
  effect: (action) => {
    const url = action.payload.url ?? NAVIGATION_ROUTES[action.payload.intent];
    if (url) {
      if (action.payload.replace) {
        history.replace(url, action.payload.state);
      } else {
        history.push(url, action.payload.state);
      }
    }
  }
});

listenerMiddleware.startListening({
  predicate: (
    action
  ): action is PayloadAction<CMxCommonApp.LaunchWorkItemConfig> =>
    action.type === launchInAmplify.pending.type,
  effect: (action) => {
    const {
      serviceLine,
      caseId,
      processId,
      hasAmplifyCaseRunV2Access,
      cursorAPIContext
    } = action.payload;
    history.push(
      `/cmx/worklist/${serviceLine}/case/${caseId}/case-run/${processId}/${
        hasAmplifyCaseRunV2Access ? 'v2/' : ''
      }`,
      { ...cursorAPIContext }
    );
  }
});

export default listenerMiddleware;
